module.exports = __webpack_public_path__ + "statics/img/right-bannner.5e9b5b8d.png";